import { render } from "./CollapseFish.vue?vue&type=template&id=4aab785e&lang=pug"
import script from "./CollapseFish.vue?vue&type=script&lang=js"
export * from "./CollapseFish.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__